
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { CompanyModel } from 'models/generated/Entities.GormCrm.Company';
import { BillingInfoDtoModel } from 'models/generated/Models.BillingInfoDto';
import { CompanySearchResultViewModel } from 'models/generated/Models.CompanySearchResultView';
import { CompanyResponsibleModel } from 'models/generated/Entities.GormCrm.CompanyResponsible';
import { OrderLineModel } from 'models/generated/Entities.GormCrm.OrderLine';
import { TransferModel } from 'models/generated/Entities.GormCrm.Transfer';


const _gormCrm_CompanyControllerHelper = new Map<string, Object>();
_gormCrm_CompanyControllerHelper.set('GetCompany', CompanyModel);
_gormCrm_CompanyControllerHelper.set('GetCompanies', CompanyModel);
_gormCrm_CompanyControllerHelper.set('GetBillingInfo', BillingInfoDtoModel);
_gormCrm_CompanyControllerHelper.set('CreateCompany', CompanyModel);
_gormCrm_CompanyControllerHelper.set('GetOrCreateCompany', CompanyModel);
_gormCrm_CompanyControllerHelper.set('GetFromVat', CompanyModel);
_gormCrm_CompanyControllerHelper.set('SearchCompanies', CompanySearchResultViewModel);
_gormCrm_CompanyControllerHelper.set('SearchCompaniesByIds', CompanySearchResultViewModel);
_gormCrm_CompanyControllerHelper.set('GetCompaniesByIds', CompanyModel);
_gormCrm_CompanyControllerHelper.set('GetCompanyResponsibles', CompanyResponsibleModel);
_gormCrm_CompanyControllerHelper.set('GetCompanyVirkDataByVatNumber', CompanyModel);
_gormCrm_CompanyControllerHelper.set('GetCompanyProducts', OrderLineModel);
_gormCrm_CompanyControllerHelper.set('TransferPlans', TransferModel);


export const gormCrm_CompanyControllerHelper = _gormCrm_CompanyControllerHelper;

